import React from "react";
import reactToText from 'react-to-text';
import {slugify} from "~services/slugify";

type PropTypes = {
    children: any;
}

/**
 * Generate automatic anchors from h2 headlines for enable linking to document parts
 */
function HeadlineTwoWithAnchor({ children }: PropTypes) {
    if (undefined === children) {
        return <div />;
    }
    const getText = reactToText(children);
    const anchorName = slugify(getText);
    return (
        <>
            <a id={`${anchorName}`} />
            <a href={`#${anchorName}`}>
                <h2>{children}</h2>
            </a>
        </>
    );
}

export default HeadlineTwoWithAnchor;
